import CustomFormatNumber from "components/CustomFormatNumber";

const ProfitValueCom = ({ profitData, className = "", textClassName = "text-12", arrow = false }) => {
    const { value = 0, percentage = 0 } = profitData ?? {};
    const differenceValue = Math.sign(value);
    return (
        <>
            {
                <div className={`d-flex align-end ${className}`}>
                    <span className={`text-16 ${differenceValue === -1 ? "danger-red-color" : "primary-color"}`}>
                        {`${differenceValue === 1 ? "+" : ""}`}
                        <CustomFormatNumber value={value} symbol="€" />{" "}
                        <span className={textClassName}>
                            <CustomFormatNumber value={percentage} symbol="%" />
                        </span>
                        {arrow && (
                            <i className={`fas fa-arrow-right text-10 mx-1 ${Math.sign(value) > 1 ? "up" : "down"}`} />
                        )}
                    </span>
                </div>
            }
        </>
    );
};

export default ProfitValueCom;